const { h, render, Component } = require('preact');
const Mapping = require('./mappings')
const {route} = require('preact-router')
const IssueView = require('../../../web_2018/frontend/components/views/email_form/common/issue_view')
const MerchantNameView = require('../../../web_2018/frontend/components/views/email_form/common/mechant_name_view')
const FlexibleFormSubmitView  = require('./flexible_form_submit')
const RecaptchaView = require('../../../web_2018/frontend/components/containers/common/recaptcha')
const Helper = require('../../../web_2018/frontend/helper.coffee')
const FileInputView = require('./file_input')

class FlexibleMain extends Component {
  constructor(props) {
    super(props);
    this.formData = {}
    this.description = {}
    this.state = {}

    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.onRecaptchaDone = this.onRecaptchaDone.bind(this);
    this.handleClosePopupEvent = this.handleClosePopupEvent.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.validateFlexibleForm = this.validateFlexibleForm.bind(this);
    this.renderSuccess = this.renderSuccess.bind(this);
    this.renderError = this.renderError.bind(this);
    this.getFlexibleComponents = this.getFlexibleComponents.bind(this);
    this.setFlexibleObjects = this.setFlexibleObjects.bind(this);
    this.updateState = this.updateState.bind(this);
    this.changeFileUpload = this.changeFileUpload.bind(this);
    this.configFromDom = Groupon.Utils.getConfigFromDom();
    this.setRecaptchaInstance = this.setRecaptchaInstance.bind(this);
  }

  changeFileUpload(data, name, isValid){
    this.setState({
      file_input: data,
      file_input_isValid : isValid,
      file_name: name
    }, () => this.validateForm());
  }

  setRecaptchaInstance (recaptchaInstance) {
    this.recaptchaInstance = recaptchaInstance
  }

  onRecaptchaDone(instance, response) {
    if(instance)
    {
      if(response) {
        let that = this;
        this.setState({'recaptcha': true, 'g-recaptcha-response': response}, () => {
          let data = that.getFormData()
          that.submitForm(data)
        });
      }
      else
        this.setState({'recaptcha': false})
    }
    else
      this.setState({'recaptcha': true})
    this.validateForm()
  }

  getUserLoggedIn() {
    return JSON.parse(Groupon.Utils.getConfigFromDom().user);
  }

  isFormValid() {
    return this.validateFlexibleForm()
  }

  validateForm() {
    if (this.isFormValid()) {
      this.enableSubmitButton();
    }
    else {
      this.disableSubmitButton();
    }
  }

  validateFlexibleForm() {
    return this.state.formObjects.every((formObject) => {
       if (formObject.required === "true")
         return formObject.isValid === true
      else
        return true
    });
  }

  onSubmitClick() {
    this.disableSubmitButton()
    if (this.isFormValid()) {
      if (this.configFromDom.isRecaptchaEnabled)
        this.recaptchaInstance.execute()
      else {
        let data = this.getFormData()
        this.submitForm(data)
      }
    }
    else {
      this.validateForm()
    }
  }

  getFormData() {
    let data = Helper.setReasonText(this.props.contactChannelParams)
    data = Helper.getBasicTicketData(data, this.props.contactChannelParams.selectedItem)
    let user = this.getUserLoggedIn()
    data['g-recaptcha-response'] = this.state['g-recaptcha-response']
    if (user) {
      data.user_name = user.firstName
      data.user_email = user.email
    }
    Object.assign(this.formData, data)
    this.formData.description = ""
    this.formData.fileData = this.state.file_input
    this.formData.fileName = this.state.file_name
    for (var key in this.description) {
        this.formData.description += this.description[key];
      }
    return this.formData
  }

  enableSubmitButton() {
    var submitButton = document.getElementsByClassName('submit-button btn')[0];
    if (submitButton)
      submitButton.removeAttribute("disabled")
  }

  getUserLoggedIn() {
    return JSON.parse(Groupon.Utils.getConfigFromDom().user);
  }

  disableSubmitButton() {
    var submitButton = document.getElementsByClassName('submit-button btn')[0];
    if (submitButton)
      submitButton.setAttribute('disabled', true)
  }

  submitForm(data) {
    Helper.createTicket(data, this.renderSuccess, this.renderError)
  }

  resetFormState() {
    var flexibleForm = document.getElementById("flexible-form");
    if (flexibleForm)
      flexibleForm.reset();
  }

  renderSuccess() {
    this.resetFormState()
    route(`/customer_support/web/thank_you?channel=email`);
  }

  renderError() {
    this.resetFormState()
    route(`/customer_support/web/error`);
  }

  handleClosePopupEvent() {
    this.setState({'recaptcha': false})
    this.props.handleClick()
  }

  createSingleObject(type, counter, required) {
    /* form object fields */
    let singleObject = {
      type: type,
      isValid: false,
      value: undefined,
      isPresent: true,
      counter: counter,
      required : required
    };
    return singleObject
  }

  getInitializedCounterObject() {
    let counterObject = {
      phone_number: 0,
      email_address: 0,
      user_name: 0,
      number: 0,
      text_field_paragraph: 0,
      text_field_line: 0,
      attachment: 0,
      calendar_date: 0,
      calendar_with_hour_slot: 0,
      dropdown: 0,
      checkbox: 0,
      text_paragraph: 0,
      radio: 0,
      date_time : 0,
      user_contact : 0,
      phone : 0,
      description : 0,
      user_contact_info : 0,
      user_identification: 0,
      divider: 0
    };
    return counterObject;
  }

  setFlexibleObjects() {
    let flexibleObjects = JSON.parse(JSON.stringify(this.props.flexibleObjects))
    let formObjects = [];
    let objectCounter = this.getInitializedCounterObject()
    let user = this.getUserLoggedIn()
    if (!user) {
      flexibleObjects[0].objects.unshift({
        type : "user_identification",
        required : "true"
      })
    }
    flexibleObjects.map((object) => {
      object.objects.map((object) => {
        ++objectCounter[object.type]
        formObjects.push(this.createSingleObject(object.type, objectCounter[object.type], object.required))
      })
    })
    this.setState ({
        'formObjects' : formObjects
    })
  }

  updateState(objectType, objectCounter, value, isValid) {
    var descriptionValue;
    var resultObject = this.state.formObjects.find(obj => {
      return obj.type === objectType && obj.counter === objectCounter
    })
    var typeCounter = `${objectType}${objectCounter}`

    resultObject.isValid = isValid
    resultObject.value = value
    if (value) {
      if (value.description) {
        this.description[typeCounter] = value.description
      }
    }
    Object.assign(this.formData, value)
    this.validateForm()
  }

  getFlexibleComponents() {
    let flexibleObjects = JSON.parse(JSON.stringify(this.props.flexibleObjects))
    let flexComponents = []
    let objectCounter = this.getInitializedCounterObject()
    let user = this.getUserLoggedIn()

    if (!user) {
      flexibleObjects[0].objects.unshift({
        type : "user_identification",
        required : "true"
      })
    }

    flexibleObjects.map((object) => {
      object.objects.map((object) => {
        ++objectCounter[object.type]
        var counter = {
          counter : objectCounter[object.type]
        }
        Object.assign(object, counter)
        const ObjectComponent = Mapping[object.type]
        if(ObjectComponent) {
          flexComponents.push(<ObjectComponent attrs={object} updateState={this.updateState} />)
        }
      })
    })
    return flexComponents
  }

  componentDidMount() {
    if (this.props.flexibleObjects) {
      this.setFlexibleObjects()
    }
    if (this.props.resetState) {
      var flexibleForm = document.getElementById("flexible-form");
      if (flexibleForm)
        flexibleForm.reset();
    }
    this.validateForm();
  }

  render() {
    var orderSelected = this.props.contactChannelParams.selectedItem
    var isClaims = orderSelected ? this.props.contactChannelParams.selectedItem.claim_id : false

    if (this.props.flexibleObjects) {
      return (
        <div class="flexible-component">
        <div>
          <span class="icon-x" onClick={this.handleClosePopupEvent}></span>
        </div>
        <form id="flexible-form">
          <div class="flexible-form">

            <div className="email-us">
              <strong>{I18n.translate('js.modules.web_2018.email_us')}</strong>
            </div>
            <strong><IssueView reason_text={this.props.contactChannelParams.title}/></strong>
            {((!(isClaims) && orderSelected) ?
              <strong><MerchantNameView order={this.props.contactChannelParams.selectedItem}/></strong> : null)}
            <span class="mandatory-field">*</span> {I18n.translate('js.modules.support.req_fields')}
            {this.configFromDom.attachmentEnabled && <FileInputView changeFileUploadState= {this.changeFileUpload}/>}
            {this.getFlexibleComponents()}
            {this.configFromDom.isRecaptchaEnabled && <RecaptchaView setRecaptchaInstance={this.setRecaptchaInstance} onRecaptchaDone={this.onRecaptchaDone}/>}
            <FlexibleFormSubmitView onSubmitClick={this.onSubmitClick}/>
          </div>
        </form>
          </div>
      )
    }
    return null
  }
}

module.exports = FlexibleMain
